// extracted by mini-css-extract-plugin
export default {"addToCartControl":"a0-z","giftCard":"b0-z","btnContainer":"c0-z","cartButton":"d0-z","disabled":"e0-z"};